export const ALERTS_INVALID = "ALERTS_INVALID";
export const ALERTS_FETCHING = "ALERTS_FETCHING";
export const ALERTS_FETCHED = "ALERTS_FETCHED";
export const ALERTS_FETCH_FAILED = "ALERTS_FETCH_FAILED";
